import React from 'react';

export default function BadgePlaceholder() {
    return (<div className="si-loader-wrap si-flexBox">
        <div className="si-loader">
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
        </div>

    </div>);
}


// WEBPACK FOOTER //
// ./src/components/onboarding/BadgePlaceholder.js